import React, { useEffect, useState } from "react";
import Theme from "./Theme";
import Container from "@material-ui/core/Container";
import Upload from "./pages/Upload";

const decode = (str: string) =>
    (str.match(/.{1,2}/g) || [])
        .map((code) => String.fromCharCode(parseInt(code, 16)))
        .join("") || "";

const App: React.FC = () => {
    const [params, setParams] = useState({ lid: "", fnm: "", lnm: "" });

    useEffect(() => {
        const path = window.location.pathname.substr(1).split("/");
        const lid = decode(path[0] || "");
        const lnm = decode(path[1] || "");
        const fnm = decode(path[2] || "");

        if (lid && fnm && lnm) {
            setParams({ lid, fnm, lnm });
        }
    }, []);

    return (
        <Theme>
            <Container maxWidth={false} disableGutters>
                <Upload params={params} />
            </Container>
        </Theme>
    );
};

export default App;
